module.exports = __webpack_public_path__ + "static/media/IBMColumbiaSiteVidStef.3ab3a8d9.mov";